import type { CovalChartSpecV1 } from "@/app-covi"
import {
  Button,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  ListTable,
  ListTableBody,
  ListTableCell,
  ListTableHead,
  ListTableHeader,
  ListTableRow,
} from "@coval/ui"
import { ChevronDown, Database } from "lucide-react"

import { reportClass } from "./ReportStyles"

export function ReportSourceData({ spec }: { spec: CovalChartSpecV1 }) {
  const columns = [...new Set(spec.data.flatMap((row) => Object.keys(row)))]
  return (
    <Collapsible className={reportClass("chart-data")}>
      <CollapsibleTrigger asChild>
        <Button
          variant="ghost"
          className="h-auto w-full justify-start gap-2 p-3 [&[data-state=open]>svg:last-child]:rotate-180"
        >
          <Database />
          View source data{" "}
          <span className="ml-auto">{spec.data.length} rows</span>
          <ChevronDown />
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className={reportClass("data-table")}>
          <ListTable
            flush
            className="whitespace-nowrap"
            aria-label={`${spec.title} source data`}
          >
            <ListTableHeader>
              <ListTableRow>
                {columns.map((column) => (
                  <ListTableHead key={column}>{column}</ListTableHead>
                ))}
              </ListTableRow>
            </ListTableHeader>
            <ListTableBody>
              {spec.data.map((row, index) => (
                <ListTableRow key={index}>
                  {columns.map((column) => (
                    <ListTableCell key={column} className="tabular-nums">
                      {typeof row[column] === "number"
                        ? row[column].toLocaleString(undefined, {
                            maximumFractionDigits: 4,
                          })
                        : String(row[column] ?? "—")}
                    </ListTableCell>
                  ))}
                </ListTableRow>
              ))}
            </ListTableBody>
          </ListTable>
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
